import React from 'react';
import { useMessageSource } from 'react-message-source';
import { useSelector } from 'react-redux';
import { useFeatureFlag } from '@modules/feature-flags/client';
import { workSelectors } from '@ducks/work';

interface Props {
  troubleShootingId: number;
}

export const ReportOutputLabel: React.FC<Props> = ({ troubleShootingId }) => {
  const { getMessage } = useMessageSource();
  const isEnabled = useFeatureFlag('ControlReportHistoryOutput');
  const history = useSelector(workSelectors.getWorkHistoryById(troubleShootingId));

  if (!isEnabled || !history) return null;

  return (
    <tr className="report-output-label">
      <th>{getMessage('reportOutput.label')}</th>
      <td>
        {history.isOutputToReport
          ? getMessage('reportOutput.yes')
          : getMessage('reportOutput.no')}
      </td>
    </tr>
  );
};
